import { MagicSearchResultDTO } from '@iota/inh-core-v1-management-client';
import {
    getCustomerLink,
    getEmployeeCaseLink,
    getEmployeeLink,
    getProductLink,
    getSolutionPartnerLink
} from 'src/app/shared/constants-and-enums/routing';

export function buildLink(dto: MagicSearchResultDTO): string {
    const entityId = dto.entityId ?? '';
    const employeeId = dto.linkData?.employeeId ?? '';
    switch (dto.entityType) {
        case 'EMPLOYEE':
            return getEmployeeLink(entityId);
        case 'CUSTOMER':
            return getCustomerLink(entityId);
        case 'SOLUTION_PARTNER':
            return getSolutionPartnerLink(entityId);
        case 'PRODUCT':
            return getProductLink(entityId);
        case 'SUBMISSION':
        case 'INSURANCE_NUMBER':
            return getEmployeeLink(employeeId);
        case 'CASE':
            return getEmployeeCaseLink(employeeId, entityId);
        default:
            return '';
    }
}
